/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconNumber7 = createReactComponent("outline", "number-7", "IconNumber7", [["path", { "d": "M8 4h8l-4 16", "key": "svg-0" }]]);

export { IconNumber7 as default };
//# sourceMappingURL=IconNumber7.mjs.map
